import dayjs from "dayjs";
import { ERP_FORMAT_CONFIG } from "../constants/erpFormatConfig";

/**
 * Number Formatters
 */
export const formatQuantity = (value) =>
  Number(value || 0).toFixed(
    ERP_FORMAT_CONFIG.DECIMAL.QUANTITY
  );

export const formatRate = (value) =>
  Number(value || 0).toFixed(
    ERP_FORMAT_CONFIG.DECIMAL.RATE
  );

export const formatAmount = (value) =>
  Number(value || 0).toFixed(
    ERP_FORMAT_CONFIG.DECIMAL.AMOUNT
  );

export const formatPercentage = (value) =>
  Number(value || 0).toFixed(
    ERP_FORMAT_CONFIG.DECIMAL.PERCENTAGE
  );

/**
 * Date Formatters
 */
export const formatDate = (value) =>
  value
    ? dayjs(value).format(
        ERP_FORMAT_CONFIG.DATE.DISPLAY
      )
    : "";

export const formatDateTime = (value) =>
  value
    ? dayjs(value).format(
        ERP_FORMAT_CONFIG.DATE.DISPLAY_DATETIME
      )
    : "";

export const formatCurrency = (value) =>
  new Intl.NumberFormat("en-IN", {
    minimumFractionDigits:
      ERP_FORMAT_CONFIG.DECIMAL.AMOUNT,
    maximumFractionDigits:
      ERP_FORMAT_CONFIG.DECIMAL.AMOUNT,
  }).format(Number(value || 0));

export const formatNumber = (value) =>
  new Intl.NumberFormat("en-IN").format(
    Number(value || 0)
  );